import { render, staticRenderFns } from "./workStart5.vue?vue&type=template&id=64bd842b&scoped=true&"
import script from "./workStart5.vue?vue&type=script&lang=js&"
export * from "./workStart5.vue?vue&type=script&lang=js&"
import style0 from "./workStart5.vue?vue&type=style&index=0&id=64bd842b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd842b",
  null
  
)

export default component.exports